import axios from 'axios'
export default function batchLoad(from, url, timeout, { headers, onComplete, onError, onBatchComplete, method }) {
    return Promise.all(from.map((row, index) =>
        new Promise((resolve) =>
            setTimeout(() => axios({ url: typeof url === 'function' ? url(row) : url, headers: typeof headers === 'function' ? headers(row) : headers, method: method ?? 'get' })
                .then(response => resolve(onComplete({ row, response })))
                .catch(reason => resolve(onError({ row, reason }))),
                index * timeout
            )
        )
    ))
        .then(resolved => onBatchComplete(resolved))

}